<template>
   <FifoComp v-if="dispobj.type == 'fifo'" 
      :swapid="mypswline" 
      :screensize="screensize"
      :globid="globid"
      :title="dispobj.type" 
      :period="widgetinterval"
      :mapobj="dispobj" />   
   <SpeedoComp v-if="dispobj.type == 'speedo'" 
      :swapid="mypswline" 
      :globid="globid"
      :screensize="screensize"
      :period="widgetinterval"
      :title="dispobj.type"
      :key="swapseq"/>   
   <SwapData v-if="dispobj.type == 'swapdata'" 
      :swapid="mypswline" 
      :globid="globid"
      :screensize="screensize"
      :period="widgetinterval"
      :key="swapseq"/>   
   <LineChart v-if="dispobj.type == 'linechart'" 
      :swapid="mypswline" 
      :globid="globid"
      :screensize="screensize"
      :period="widgetinterval"
      :title="dispobj.type"
      :subtype=dispobj.subtype />   
   <SwapMap v-if="dispobj.type == 'swapmap'" 
      :globid="globid"
      :period="widgetinterval"
      :mapid=dispobj.mapid />   
   <SwapMapV v-if="dispobj.type == 'swapmapv'" 
      :globid="globid"
      :period="widgetinterval"
      :mapid=dispobj.mapid />   
   <SwapTable v-if="dispobj.type == 'swaptable'" 
      :period="widgetinterval"
      :screensize="screensize" 
      :display="dispobj.display" />

</template>

<script>
import SpeedoComp from './SpeedoComp.vue' 
import FifoComp from './FifoComp.vue' 
import SwapData from './SwapData.vue' 
import LineChart from './LineChart.vue' 
import SwapMap   from './SwapMap.vue' 
import SwapMapV  from './SwapMapV.vue' 
import SwapTable   from './SwapTable.vue' 

export default {
  name: 'ProswComp',
  components: {
      SpeedoComp, FifoComp, SwapData, LineChart, SwapMap, SwapMapV, SwapTable
  },
  data () {
    return { "interval" : 0 }
  },
  props: {
    globid : String,
    screensize : String,
    dispobj : Object
  },
  mounted() {
    console.log ( "ProswComp " + this.swapid + " Seq:" + this.swapseq) ;
  },
  computed : {
    widgetinterval() {
      if (this.dispobj.interval)
        return parseInt(this.dispobj.interval) ;
      return this.$store.getters.interval ;
    },
    mypswline() {
       let x = parseInt (this.dispobj.pswline) ;
       if (Number.isNaN(x))
         x = this.$store.getters.active_swap ;
       return x.toString() ;
    },
    swapseq() {
      let swap = this.$store.getters.getswap_byid(this.dispobj.pswline) ;
      if (! swap) return 0 ;
      return swap.seq ;	
    }
  }
}
// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
</script>




